import {
    CREATE_ACCOUNT_SUCCESS,
    CREATE_INVITATION_SUCCESS,
    DELETE_INVITATION_SUCCESS,
    DELETE_ACCOUNT_SUCCESS,
    FETCH_ACCOUNT,
    FETCH_ACCOUNTS,
    FETCH_ACCOUNTS_FAILURE,
    FETCH_ACCOUNTS_SUCCESS,
    FETCH_ACCOUNT_FAILURE,
    FETCH_ACCOUNT_SUCCESS,
    FETCH_INVITATIONS,
    FETCH_INVITATIONS_FAILURE,
    FETCH_INVITATIONS_SUCCESS,
    SORT_ASC,
    UPDATE_ACCOUNT_SUCCESS,
    ACCOUNTS_LIST_FILTER_UPDATE,
    ACCOUNTS_LIST_FILTER_CATEGORY,
    ACCOUNTS_LIST_PAGE,
    ACCOUNTS_LIST_SORT,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'name',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 12,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ACCOUNT:
        case FETCH_ACCOUNTS:
        case FETCH_INVITATIONS:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_ACCOUNT_FAILURE:
        case FETCH_INVITATIONS_FAILURE:
        case FETCH_ACCOUNTS_FAILURE:
            return Object.assign({}, state, {
                data: {},
                ids: [],
                loading: false,
                offset: 0,
                size: 0,
                total: 0,
            });

        case FETCH_ACCOUNT_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, { [action.payload.id]: action.payload }),
                ids: [
                    ...state.ids,
                    ...action.payload.id,
                ],
                loading: false,
            });

        case FETCH_ACCOUNTS_SUCCESS:
        case FETCH_INVITATIONS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: parseInt(action.payload.total, 10),
            });

        case CREATE_ACCOUNT_SUCCESS:
        case CREATE_INVITATION_SUCCESS:
        case UPDATE_ACCOUNT_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.payload.id]: action.payload,
                }),
                loading: false,
            });

        case DELETE_ACCOUNT_SUCCESS:
        case DELETE_INVITATION_SUCCESS:
            const { id } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        case ACCOUNTS_LIST_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case ACCOUNTS_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case ACCOUNTS_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case ACCOUNTS_LIST_FILTER_UPDATE:
            const normalisedStatePayload = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, normalisedStatePayload);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/accountsReducer.js